import {
    Typography,
    Grid,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch } from 'react-redux';
import { toggleModal } from '../../reducers/modalReducer';
import { INNERPAGE_PRICING_PLAN } from '../../constants/Plans';

const renderTitle = (titleText, handleModal) => {
    if (titleText.includes('|')) {
        const [beforePipe] = titleText.split('|');
        return (
            <div
                style={{
                    color: `${beforePipe.includes("Try us out for FREE - no credit card required") ? "#10B981" : "#151313"}`
                }}
            >
                {beforePipe}
                <img
                    src={require('../../../images/helpCircle.svg')}
                    alt="helpCircle"
                    width={16}
                    height={16}
                    className='ml0-5rem'
                />
            </div>
        );
    } else if (titleText.includes('&')) {
        const [beforePipe] = titleText.split('&');
        return (
            <div
                style={{
                    color: `${beforePipe.includes("Try us out for FREE - no credit card required") ? "#10B981" : "#151313"}`
                }}
            >
                {beforePipe}
                <img
                    src={require('../../../images/infoIcon.svg')}
                    onClick={() => handleModal(titleText)}
                    alt="helpCircle"
                    width={16}
                    height={16}
                    className='ml0-5rem cp'
                />
            </div>
        );
    }
    return (
        <div
            style={{
                color: `${titleText.includes("Try us out for FREE - no credit card required") ? "#10B981" : "#151313"}`
            }}
        >
            {titleText}
        </div>
    )
};

const FeatureRow = ({ label, values, plans, handleModal, subscription, handlePaymentPopup, disabled }) => {
    return (
        <Grid
            container
            spacing={2}
            sx={{
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #8282823a',
                height: label === "BUY_BUTTONS" ? '80px' : '60px',
                verticalAlign: 'center',
                margin: '0px 0px 0px -8px',
                alignItems: 'center'
            }}
        >
            <Grid
                xs={plans.length === 2 ? 7 : plans.length === 3 ? 5 : plans.length === 4 ? 3 : 4}
                sx={{
                    ...(plans.length === 1 && { maxWidth: '80% !important', width: '80%!important', flexBasis: '80% !important' }),
                }}
            >
                <Typography variant="body2" className='tal fw400 df aic pl0-5rem' sx={{ fontSize: '13px !important' }}>
                    {
                        label === "BUY_BUTTONS" ? "" : renderTitle(label, handleModal)
                    }
                    {
                        label.includes('Sync') ? <>
                            <img className='ml1rem' src={require('../../../images/dataRepo/dataroom.svg')} alt="dataRooms" />
                        </> : (label.includes('Unaudited Certification') || ['Chargeable quarterly reviews', 'Quarterly portfolio Reviews'].includes(label)) ? <div className='df aic jcc'>
                            <img className='ml0-5rem' src={require('../../../images/certifications/certificationPricing1.svg')} alt="certificationPricing" />
                            <img className='ml0-5rem' src={require('../../../images/certifications/certificationPricing2.svg')} alt="certificationPricing2" />
                            <img className='ml0-5rem' src={require('../../../images/certifications/certificationPricing3.svg')} alt="certificationPricing3" />
                        </div> : null
                    }
                </Typography>
            </Grid>
            {plans.map((plan, index) => (
                <Grid
                    xs={plans.length === (index + 1) ? 3 : 2}
                    sx={{
                        ...(plans.length === 1 && { maxWidth: '20% !important', width: '20%!important', flexBasis: '20% !important' }),
                    }}
                    key={plan}
                >
                    <Typography className='fw400 fs11px pr' sx={{ fontSize: '13px !important' }} align="center">
                        {values[plan] && typeof values[plan] === 'string' && values[plan].includes("image") ? (
                            <img className={`pa ${plans.length === (index + 1) ? 'w70 mxa' : 'w100'}`} style={{ left: `${plans.length === (index + 1) ? '15%' : '0'}`, top: '-30px' }} src={require('../../../images/pricing-page/proPlus.png')} alt="info" />
                        ) : typeof values[plan] === 'boolean' ? (
                            values[plan] ? <img src={require('../../../images/check.svg')} alt='allowedIcon' /> : plan.toLowerCase().includes('pro plus') ? '' : '-'
                        ) : (label === "BUY_BUTTONS") ? plans.length === (index + 1) ? <>
                            <div className='w100 mxa tac pb1rem df aic jcc'>
                                <button
                                    className="br50px py0-75rem cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac bg1 c4 bw1px bss bo4 br50px df aic jcc px0-5rem w100"
                                    type="button"
                                    style={{ maxHeight: "45px", paddingLeft: "8px", paddingRight: "8px", width: "180px" }}
                                    onClick={() => window.open("https://koalendar.com/e/meet-with-mark-bernstein")}
                                    disabled={disabled}
                                >
                                    Book a call
                                </button>
                            </div>
                        </> : <> {
                            subscription?.toLowerCase() !== plan?.toLowerCase() ? <div className='w100 mxa tac pb1rem'>
                                <button
                                    className="br50px py0-75rem cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac bg4 c1 df aic jcc px0-5rem mxa"
                                    type="button"
                                    style={{ maxHeight: "45px", paddingLeft: "8px", paddingRight: "8px", width: "180px" }}
                                    onClick={disabled ? undefined : () => handlePaymentPopup(plan)}
                                    disabled={disabled}
                                >
                                    {
                                        plan !== "FREE" ? values[plan] : <div className='df aic jcc fdc fw600'> Get Started <p className='fs10px fw400'>No credit card required</p></div>
                                    }
                                </button>
                            </div> : ''
                        }
                        </> : values[plan] || '-'}
                    </Typography>
                </Grid>
            ))}
        </Grid>
    );
};

const InnerFeatureAccordion = ({ items, plans, tab, subscription, selectedCompany, handlePaymentPopup }) => {
    const dispatch = useDispatch();
    const activeTab = tab;
    const disabled = !(selectedCompany && Object.keys(selectedCompany)?.length);

    const handleModal = () => {
        if (disabled) return;
        dispatch(toggleModal({ open: 'pricingPage' }));
    };

    return (
        <Accordion defaultExpanded disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#4A67FF' }} />}
                sx={{
                    padding: '12px 16px',
                    backgroundColor: '#FFDB4299'
                }}
            >
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    sx={{
                        paddingTop: '0px',
                        paddingBottom: '0px',
                        margin: '0px 0px 0px -8px',

                    }}
                >
                    <Grid
                        xs={plans.length === 2 ? 7 : plans.length === 3 ? 5 : plans.length === 4 ? 3 : 4}
                        sx={{
                            ...(plans.length === 1 && { maxWidth: '80% !important', width: '80%!important', flexBasis: '80% !important' }),
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 600,
                                textAlign: 'left',
                                display: 'flex',
                                alignItems: 'center',
                                paddingLeft: '8px'
                            }}
                        >
                            {renderTitle("We Get You Organised", handleModal)}
                        </Typography>
                    </Grid>
                    {plans.map((plan, index) => (
                        <Grid
                            xs={plans.length === (index + 1) ? 3 : 2}
                            key={plan}
                            sx={{
                                paddingTop: "0px !important",
                                ...(plans.length === 1 && { maxWidth: '20% !important', width: '20%!important', flexBasis: '20% !important' }),
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '13px !important',
                                    fontWeight: '600',
                                    marginLeft: '1rem'
                                }}
                                align="center"
                            >
                                {INNERPAGE_PRICING_PLAN[activeTab]?.['subTitle']?.[plan] && (
                                    <p className='fs11px fw400 mb0rem'>
                                        {INNERPAGE_PRICING_PLAN[activeTab]['subTitle'][plan]}
                                    </p>
                                )}
                                {plan}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: '0px' }}>
                <Paper elevation={0} sx={{ margin: "0px !important" }}>

                    <div style={{ padding: '0 16px 0px' }}>
                        {Object.entries(items).map(([feature, value]) => {
                            return (
                                <FeatureRow
                                    handlePaymentPopup={handlePaymentPopup}
                                    selectedCompany={selectedCompany}
                                    subscription={subscription}
                                    activeTab={activeTab}
                                    key={feature}
                                    label={feature}
                                    values={value}
                                    plans={plans}
                                    handleModal={handleModal}
                                    disabled={disabled}
                                />
                            )

                        })}
                    </div>
                </Paper>
            </AccordionDetails>
        </Accordion>
    );
};

export default InnerFeatureAccordion;
